import { Injectable, Injector } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { TemplateModel } from '@fi-app/template/template.model';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ILightWeightObjectCollection } from '@fi-shared/models';
import { ILightWeightTemplate, ITemplateUsage } from '@fi-app/document-template/document-template';
import { FiLocalSearchParameterModel } from '@fi-shared/fi-local-search2/fi-local-search-parameter.model';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';
import { LoadingService } from '@fi-shared/fi-loading/loading.service';
import { FiPrintDownloadService } from '@fi-shared/fi-print-download/fi-print-download.service';

@Injectable()
export class DocumentTemplateService {
    constructor(
        private fiBackend: FiBackendService,
        private fiLoading: LoadingService,
        private injector: Injector,
        private fiPrintDownloadService: FiPrintDownloadService,
    ) {}

    getTemplatesListData(parameter: IItemsListParameterBase) {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<TemplateModel>>(
            'Template/Template/GetTemplatesListData',
            parameter,
        );
    }

    GetTemplates(templateParameterApiModel) {
        return this.fiBackend.fetchObjectsPost(
            'Template/Template/GetTemplates',
            TemplateModel,
            templateParameterApiModel,
        );
    }

    GetTemplatesCount(templateParameterApiModel) {
        return this.fiBackend.fetchDataPost<number>('Template/Template/GetTemplatesCount', templateParameterApiModel);
    }

    GetLightWeightObjectsForLocalSearch(templateParameterApiModel) {
        return this.fiBackend.fetchDataPost<ILightWeightObjectCollection>(
            'Template/Template/GetLightWeightObjectsForLocalSearch',
            templateParameterApiModel,
        );
    }

    DeleteTemplates(idsToDelete: number[]) {
        return this.fiBackend.fetchDataPost('Template/Template/DeleteTemplates', idsToDelete);
    }

    SaveTemplate(templateApiModel) {
        return this.fiBackend.fetchDataPost<number>('Template/Template/SaveTemplate', templateApiModel);
    }

    GetTemplate(
        id: number,
        args?: {
            skipAccessCheck?: boolean;
        },
    ) {
        if (!args) {
            args = {};
        }

        return new Promise<TemplateModel>((resolve, reject) => {
            this.fiBackend
                .fetchData<any>(`Template/Template/GetTemplate/${id}` + (args.skipAccessCheck ? '/true' : ''))
                .then((response) => {
                    const model = new TemplateModel(response, this.injector);
                    resolve(model);
                }, reject);
        });
    }

    GenerateTemplatePreviewFileImage(TemplateId, Source) {
        return this.fiPrintDownloadService.generatePreviewFileImage(ObjectTypes.Template, TemplateId, Source);
    }

    RestoreTemplates(restoreIds: number[]) {
        return this.fiLoading.trackPromise(
            this.fiBackend.fetchDataPost<void>('Template/Template/RestoreTemplates', restoreIds),
        );
    }

    GetLightWeightTemplates() {
        return this.fiBackend.fetchData<ILightWeightTemplate[]>('Template/Template/GetLightWeightTemplates');
    }

    IsTemplateInUsed(Id) {
        return this.fiBackend.fetchData<number>(`Template/Template/IsTemplateInUsed/${Id}`);
    }

    getTemplateUsages(templateIds: number[]) {
        return this.fiBackend.fetchDataPost<ITemplateUsage[]>(`Template/Template/GetTemplateUsages`, templateIds);
    }
}
